import './index'
import axios from '@/http/axios'

async function getGifts () {
  const token = localStorage.accessToken
  return axios.get('/api/gifts', {
    params: {
    },
    headers:{
      Authorization: `Bearer ${token}`
    }
  })
}
async function getGift (giftId) {
  const token = localStorage.accessToken

  return axios.get(`/api/gifts/${giftId}`, {
    params: {
    },
    headers:{
      Authorization: `Bearer ${token}`
    }
  })
}

async function saveGift (payload) {
  const token = localStorage.accessToken
  const giftForm = new FormData()
  
  if (payload.contentImage) {
    giftForm.append('contentImage', payload.contentImage)
  }
  if (payload.giftId) {
    giftForm.append('giftId', payload.giftId)
  }
  giftForm.set('name', payload.name)
  giftForm.set('price', payload.price)
  return axios.post('/api/gifts', giftForm, {
    headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization': `Bearer ${token}`
    }
  })
  
  
}
async function updateGift (payload) {
  const token = localStorage.accessToken

  return axios.put(`/api/gifts/${payload.giftId}`, payload, {
    headers:{
      Authorization: `Bearer ${token}`
    }
  })
}

async function deleteGift (giftId) {
  const token = localStorage.accessToken

  return axios.delete(`/api/gifts/${giftId}`, {
    headers:{
      Authorization: `Bearer ${token}`
    }
  })
}
export {
  getGift, getGifts, saveGift, updateGift, deleteGift
}
